import EventGuidelines from './EventGuidelines';

export default EventGuidelines;
